import * as React from 'react';
import * as classnames from 'classnames';

interface MenuProps {
    items: any[];
    selectedItem: any;
    disabled?: boolean;
    onClickItem: (item) => void;
}

const Menu: React.FC<MenuProps> = ({
    items,
    selectedItem,
    disabled,
    onClickItem
}: MenuProps) => {
    const twoRows = items.length >= 8;

    return (
        <div
            style={{
                width: '100%',
                display: 'grid',
                gridTemplateColumns: `repeat(${
                    twoRows ? Math.ceil(items.length / 2) : items.length
                },1fr)`,
                gridTemplateRows: `repeat(${twoRows ? 2 : 1}, 1fr)`
            }}
        >
            {items.map((item, i) => (
                <span
                    className={classnames('menu--item', {
                        active: item.value == selectedItem,
                        disabled: disabled || 'disabled' in item
                    })}
                    key={`${i}-${item.value}`}
                    onClick={() => onClickItem(item)}
                >
                    {item.label}
                </span>
            ))}
        </div>
    );
};

export default Menu;
